import { InfoTooltip } from "@/lib/dashboard/InfoTooltip";

interface DetailKpiTileProps {
  label: string;
  value: string;
  info?: string;
  /**
   * Il colore non decora: `danger` e' per i numeri su cui si deve agire, `success` per
   * quelli gia' a posto. Il resto resta neutro, altrimenti il rosso smette di significare
   * qualcosa.
   */
  tone?: "neutral" | "danger" | "success";
  /**
   * Il numero di riferimento della riga -- il totale. Sfondo pieno e cifra piu' grande:
   * e' quello che si cerca per primo, gli altri sono la sua scomposizione. Una sola
   * casella per riga puo' permetterselo, altrimenti l'enfasi non enfatizza piu' niente.
   */
  emphasis?: boolean;
}

/** Riquadro KPI delle schede di dettaglio (cliente, consulente). */
export function DetailKpiTile({
  label,
  value,
  info,
  tone = "neutral",
  emphasis = false,
}: DetailKpiTileProps) {
  const valueTone =
    tone === "danger"
      ? "text-red-600"
      : tone === "success"
        ? "text-emerald-600"
        : "text-gray-900";

  return (
    <div
      className={`rounded-lg border px-3 py-2.5 ${
        emphasis ? "border-gray-300 bg-gray-50" : "border-gray-200 bg-white"
      }`}
    >
      <div
        className={`flex items-center gap-1.5 text-xs ${
          emphasis ? "text-gray-600 font-medium" : "text-gray-500"
        }`}
      >
        <span className="truncate">{label}</span>
        {info && <InfoTooltip text={info} />}
      </div>
      <div
        className={`font-semibold mt-0.5 ${emphasis ? "text-xl" : "text-lg"} ${valueTone}`}
      >
        {value}
      </div>
    </div>
  );
}

export default DetailKpiTile;
